import React, { Component } from "react";
import {
  ImagePicker,
  WingBlank,
  SegmentedControl,
  List,
  TextareaItem,
  Button,
  InputItem,
} from "antd-mobile";
import { createForm } from "rc-form";
import axios from "axios";
import "./uploadImg.scss";

export class uploadImg extends Component {
  state = {
    files: [],
    file: {},
    inputId: "",
    textareaValue: "",
    inputvlaue: "",
    inputName: "",
  };
  render() {
    return (
      <div>
        <h3>
          巡更点：
          {this.state.inputName}
        </h3>
        <h4 className="Picker">请上传图片</h4>
        <ImagePicker
          files={this.state.files}
          onChange={this.onChange}
          onImageClick={(index, fs) => console.log(index, fs)}
        />
        <TextareaItem
          title="巡更人:"
          data-seed="logId"
          onChange={this.TextareaChange.bind(this)}
        />
        <div className="quming">请备注失败原因</div>
        <TextareaItem
          rows={5}
          count={100}
          onChange={this.handleTextareaChange.bind(this)}
        />

        <Button type="primary" onClick={this.handleClickTJ}>
          提交
        </Button>
      </div>
    );
  }
  handleTextareaChange = (e) => {
    this.setState({
      inputvlaue: e,
    });
  };
  TextareaChange = (e) => {
    this.setState({
      textareaValue: e, //不能使用e.target.value 获取值
    });
  };
  onChange = (files, type, index) => {
    console.log(files[0].file, type, index);
    this.setState({
      files,
      file: files[0].file,
    });
  };
  
  componentWillMount = () => {
    this.setState({
      inputId: this.props.match.params.id,
      inputName: this.props.match.params.name,
    });
  };
  handleClickTJ = () => {
    console.log(
      "daying",
      this.state.inputId,
      this.state.inputvlaue,
      this.state.textareaValue
    );
    let f = new FormData();
    f.append("file", this.state.file);
    f.append("pointId", this.state.inputId);
    // f.append("pointId", 8);
    f.append("inspector", this.state.textareaValue);
    f.append("remark", this.state.inputvlaue);
    //提交事件
    axios
      .post("api/patrol/point/punch_in/failure", f, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          alert("提交成功");
          this.props.history.push({
            pathname: "/menu",
          });
        }
      })
      .catch((error) => {
        alert("提交失败");
      });
  };
}

export default uploadImg;
